// Delegation also supports slides reloaded in the theme editor.
(() => {
  if (window.flowQuizAnchorBound) return;
  window.flowQuizAnchorBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-flow-quiz-link] a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const id = link.getAttribute('href').slice(1);
    const section = document.getElementById(id);
    if (!section) return;
    const startButton = section.querySelector('[data-start]');
    const target = startButton && !startButton.closest('[hidden]') ? startButton : section;
    event.preventDefault();
    let headerBottom = 0;
    document.querySelectorAll('[data-flow-header-shell], sticky-header, .header--sticky').forEach((header) => {
      const position = getComputedStyle(header).position;
      if (position !== 'fixed' && position !== 'sticky') return;
      const rect = header.getBoundingClientRect();
      if (rect.width && rect.height) headerBottom = Math.max(headerBottom, rect.bottom);
    });
    target.focus({ preventScroll: true });
    window.scrollTo({
      top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerBottom - 16),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
  });
})();
